/**
 * Sync — resolve the archival Players an ingest minted to the real
 * Player behind them.
 *
 * TWO COMMIT MODES share one resolution ladder, one preview and one
 * review UI. Only what commit WRITES differs:
 *
 *   "data"  remaps every Player FK to the canonical row and deletes the
 *           archival one, so runs and wickets accrue on the real
 *           profile. Thorough, and irreversible — no undo.
 *   "name"  touches no delivery, wicket or team sheet. Links the
 *           archival row to the canonical one and copies its name, so
 *           the analyzer can group a career that spans competitions
 *           while the archive keeps its own rows. Reversible.
 *
 * Both write PlayerAlias, which is what makes the NEXT ingest of the
 * same name resolve itself. The backend defaults to "data" when no mode
 * is sent, so older callers are unaffected.
 *
 * Two scopes share the same engine:
 *   * Competition — bulk clean-up right after ingest (all matches).
 *   * Match       — surgical single-match fix from the Matches admin
 *                   drill-down. Payload shape mirrors competition, with
 *                   `preview.match` in place of `preview.competition`.
 * Endpoints live under /api/admin/v2/, IsSuperuser-gated.
 */
import api from "./axios";

export const getTournamentSyncPreview = (competitionId) =>
  api.get(`/api/admin/v2/tournament-sync/${competitionId}/preview/`);

export const commitTournamentSync = (competitionId, mappings, mode = "name") =>
  api.post(`/api/admin/v2/tournament-sync/${competitionId}/commit/`, {
    mappings,
    mode,
  });

export const getMatchSyncPreview = (matchId) =>
  api.get(`/api/admin/v2/match-sync/${matchId}/preview/`);

export const commitMatchSync = (matchId, mappings, mode = "name") =>
  api.post(`/api/admin/v2/match-sync/${matchId}/commit/`, {
    mappings,
    mode,
  });
